import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, output } from '@angular/core';
import { IRemisionLock } from '../../../domain/interfaces/firebase/IremisionLock';
import { PrimengModule } from '../../../primeng/primeng.module';

export type EstadoPaso = 'pendiente' | 'en-progreso' | 'completado';

export interface PasoPipeline {
    label: string;
    descripcion: string;
    estado: EstadoPaso;
}

@Component({
    selector: 'sura-pipeline-estado-novedad',
    imports: [CommonModule, PrimengModule],
    templateUrl: './pipeline-estado-novedad.component.html',
    styleUrl: './pipeline-estado-novedad.component.scss'
})
export class PipelineEstadoNovedadComponent implements OnChanges {

    @Input() estadoLock: IRemisionLock | null | undefined = undefined;
    @Input() visible: boolean = false;
    @Input() closable: boolean = false;

    cerrar = output<void>();

    pasos: PasoPipeline[] = [
        { label: 'Novedades',     descripcion: 'Envío de novedad',                    estado: 'en-progreso' },
        { label: 'Programación',  descripcion: 'Creación de citas / novedades',        estado: 'pendiente'   },
        { label: 'Agenda',        descripcion: 'Citas almacenadas en el programador',  estado: 'pendiente'   },
    ];

    get todoCompletado(): boolean {
        return this.estadoLock === null;
    }

    ngOnChanges(): void {
        this.actualizarPasos();
    }

    onCerrar(): void {
        this.cerrar.emit();
    }

    private actualizarPasos(): void {
        if (this.estadoLock === undefined) return;

        if (this.estadoLock === null) {
            this.pasos = this.pasos.map(p => ({ ...p, estado: 'completado' }));
            return;
        }

        const { estadoNovedades, estadoProgramacion, estadoAgenda } = this.estadoLock;

        this.pasos[0].estado = estadoNovedades ? 'completado' : 'en-progreso';
        this.pasos[1].estado = estadoProgramacion ? 'completado' : estadoNovedades ? 'en-progreso' : 'pendiente';
        this.pasos[2].estado = estadoAgenda       ? 'completado' : estadoProgramacion ? 'en-progreso' : 'pendiente';
    }
}
